import { useTranslation } from 'react-i18next';
import numbro from 'numbro';

import {
  CurrencyType,
  getCurrencyDetails,
} from '../../../constants/currencies';
import { SVGIconType } from '../../../constants/svgIcon';
import { CountDownText, CurrencyNode, PngIcon, SvgIcon } from '../../Molecules';
import { BasicPopupContainer } from '../Containers/BasicPopupContainer';

import styles from './NotEnoughTokenStaminaPopup.module.css';

type NotEnoughTokenStaminaPopupProps = {
  currencyType: CurrencyType;
  feeAmount: number;
  currentAmount: number;
  totalAmount: number | undefined;
  willRefillAt: Date | undefined;
  isTrialUser: boolean | undefined;
  onPrimary: () => void;
  onCancel: () => void;
};

export const NotEnoughTokenStaminaPopup = (
  props: NotEnoughTokenStaminaPopupProps,
) => {
  const {
    currencyType,
    feeAmount,
    currentAmount,
    totalAmount,
    willRefillAt,
    isTrialUser,
    onPrimary,
    onCancel,
  } = props;
  const { t } = useTranslation();
  const currencyDetails = getCurrencyDetails(currencyType);

  return (
    <BasicPopupContainer
      primaryButtonLabel={t(isTrialUser ? 'Register' : 'Get More')}
      primaryButtonIcon={
        isTrialUser ? (
          <SvgIcon name={SVGIconType.Register} width={24} height={24} />
        ) : undefined
      }
      onPrimaryButtonClick={onPrimary}
      onSecondaryButtonClick={isTrialUser ? undefined : onCancel}
    >
      <div className={styles.popupContent}>
        <div className={styles.title}>
          {t(currencyDetails.notEnoughMessage)}
        </div>
        <div className={styles.greenRibbon}>
          <CurrencyNode
            currencyType={currencyType}
            amount={feeAmount}
            withBox={false}
          />
        </div>
        <div className={styles.staminaInfo}>
          <div className={styles.staminaText}>{t('You have:')}</div>
          <div className={styles.staminaDetails}>
            <PngIcon name={currencyDetails.icon} width={24} height={24} />
            {totalAmount ? (
              <span>{`${currentAmount} / ${totalAmount}`}</span>
            ) : (
              <span>
                {numbro(currentAmount).format({ thousandSeparated: true })}
              </span>
            )}
          </div>
          {!isTrialUser && willRefillAt ? (
            <div className={styles.refillTextBar}>
              <SvgIcon name={SVGIconType.Timer} className={styles.timerIcon} />
              <CountDownText
                timestamp={willRefillAt.getTime()}
                label={t('Next Refill: ')}
                className={styles.staminaText}
              />
            </div>
          ) : null}
        </div>
        {isTrialUser ? (
          <div className={styles.registerText}>
            {t('Register to get FREE Basic Plan!')}
          </div>
        ) : null}
      </div>
    </BasicPopupContainer>
  );
};
